import React from "react";
import {Button} from "@material-ui/core";

const ActionButton = ({text, className, size, color, variant, type, onClick, icon, value, disabled}) => {

    return (
        <Button
            value={value}
            type={type}
            variant={variant}
            className={className}
            size={size}
            color={color}
            onClick={onClick}
            startIcon={icon}
            disabled={disabled}>
            {text}
        </Button>
    )
}

ActionButton.defaultProps = {
    variant: 'contained',
    size: 'small',
    color: 'primary',
    type: 'button',
    disabled: false
}
export default ActionButton